import { WidgetProps } from '../../components/Widget/Widget';

export const widgetData: WidgetProps[] = [
  {
    title: 'REVIEW NEW DEALS',
    action: { filter: 'new' },
    description: 'See the new deals created in the past week (last 7 days).',
  },
  {
    title: 'BEST FIT',
    action: { filter: 'fitScore' },
    description: 'See deals with 5/5 Fit Score',
  },
  {
    title: 'SHARED PROJECTS',
    action: { filter: 'shared' },
    description: 'See projects shared with me by other team members.',
  },
  {
    title: 'DEALS READY FOR DUE DILIGENCE',
    action: { filter: 'completion' },
    description: 'See deals with over 75% data completeness, ready for due diligence',
  },
];
